exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-group-box[data-v-e37bbb22] {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n", ""]);

// exports
